/* Leucadia <-> Dawn integration glue.
 * On /pages/blanco|reposado|anejo:
 *   1. Insert a BUY NOW button ABOVE the original button (gold, primary)
 *   2. Rewrite the original BUY NOW -> ADD TO CART (noir, secondary)
 *   Identical dimensions. 36px breathing room above the BUY NOW (44px on mobile),
 *   10px gap between the two CTAs so they pair as one group.
 */
(function () {
  'use strict';

  var PAGE_TO_LEU_HANDLE = {
    '/pages/blanco':   'leucadia®-blanco-tequila-copy',
    '/pages/reposado': 'leucadia®-reposado-tequila',
    '/pages/anejo':    'leucadia®-anejo-tequila'
  };

  var CHL_HANDLE_TO_LEU_HANDLE = {
    'leucadia®-silver-tequila':   'leucadia®-blanco-tequila-copy',
    'leucadia®-blanco-tequila':   'leucadia®-blanco-tequila-copy',
    'leucadia®-reposado-tequila': 'leucadia®-reposado-tequila',
    'leucadia®-anejo-tequila':    'leucadia®-anejo-tequila',
    'leucadia®-añejo-tequila':    'leucadia®-anejo-tequila'
  };

  function injectBuyNowStyles() {
    if (document.getElementById('leu-buy-now-global-styles')) return;
    var s = document.createElement('style');
    s.id = 'leu-buy-now-global-styles';
    s.textContent = [
      '.leu-buy-now-wrap-injected {',
      '  width: 100% !important;',
      '  display: flex !important;',
      '  justify-content: center !important;',
      '  margin: 36px auto 10px auto !important;',
      '}',
      '.leu-atc-restyled { margin-top: 0 !important; }',
      '.leu-buy-now-injected,',
      '.leu-atc-restyled {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  text-align: center !important;',
      '  width: 100% !important;',
      '  max-width: 360px !important;',
      '  margin-left: auto !important;',
      '  margin-right: auto !important;',
      '  min-height: 50px !important;',
      '  padding: 14px 24px !important;',
      '  font-family: inherit !important;',
      '  font-size: 13px !important;',
      '  font-weight: 700 !important;',
      '  letter-spacing: 2px !important;',
      '  line-height: 1 !important;',
      '  text-transform: uppercase !important;',
      '  text-decoration: none !important;',
      '  border-radius: 0 !important;',
      '  box-shadow: none !important;',
      '  cursor: pointer !important;',
      '  box-sizing: border-box !important;',
      '  white-space: nowrap !important;',
      '  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease !important;',
      '}',
      '.leu-buy-now-injected, .leu-buy-now-injected:link, .leu-buy-now-injected:visited {',
      '  background: #D4AF50 !important;',
      '  background-color: #D4AF50 !important;',
      '  color: #080808 !important;',
      '  border: 1.5px solid #D4AF50 !important;',
      '  opacity: 1 !important;',
      '}',
      '.leu-buy-now-injected > * { display: inline-block !important; width: auto !important; color: inherit !important; }',
      '.leu-buy-now-injected:hover, .leu-buy-now-injected:focus {',
      '  background: #B8943F !important;',
      '  background-color: #B8943F !important;',
      '  color: #080808 !important;',
      '  border-color: #B8943F !important;',
      '}',
      '.leu-buy-now-injected:disabled { opacity: 0.4 !important; cursor: not-allowed !important; }',
      '.leu-atc-restyled, .leu-atc-restyled:link, .leu-atc-restyled:visited {',
      '  background: #080808 !important;',
      '  background-color: #080808 !important;',
      '  color: #FFFFFF !important;',
      '  border: 1.5px solid #080808 !important;',
      '}',
      '.leu-atc-restyled:hover, .leu-atc-restyled:focus {',
      '  background: #1a1a1a !important;',
      '  background-color: #1a1a1a !important;',
      '  color: #D4AF50 !important;',
      '  border-color: #1a1a1a !important;',
      '}',
      '@media (max-width: 749px) {',
      '  .leu-buy-now-wrap-injected { margin: 44px auto 10px auto !important; }',
      '  .leu-buy-now-injected,',
      '  .leu-atc-restyled {',
      '    max-width: 100% !important;',
      '    min-height: 54px !important;',
      '    font-size: 14px !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function leuCartCount() {
    return (window.LeucadiaCart && window.LeucadiaCart.count) ? window.LeucadiaCart.count() : 0;
  }

  function hijackCartLinks() {
    var sels = ['#cart-icon-bubble', '.header__icon--cart', 'a[href="/cart"]', 'a[href$="/cart"]'];
    var nodes = document.querySelectorAll(sels.join(','));
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.leuHijacked) continue;
      el.dataset.leuHijacked = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (window.LeucadiaCart) window.LeucadiaCart.open();
      }, true);
    }
  }

  function resolveLeuHandle(el) {
    if (!el) return null;
    var explicit = el.getAttribute && el.getAttribute('data-leu-handle');
    if (explicit) return explicit.toLowerCase();
    var href = el.getAttribute && el.getAttribute('href');
    if (href) {
      try {
        var u = new URL(href, location.origin);
        if (/coasthighwayliquor\.myshopify\.com$/i.test(u.hostname)) {
          var m = u.pathname.match(/\/products\/([^\/?#]+)/);
          if (m) {
            var chlHandle = decodeURIComponent(m[1]).toLowerCase();
            if (CHL_HANDLE_TO_LEU_HANDLE[chlHandle]) return CHL_HANDLE_TO_LEU_HANDLE[chlHandle];
            if (window.LEUCADIA_CHL && window.LEUCADIA_CHL.lookup && window.LEUCADIA_CHL.lookup(chlHandle)) return chlHandle;
          }
        }
      } catch (e) {}
    }
    var pageHandle = PAGE_TO_LEU_HANDLE[location.pathname.toLowerCase()];
    if (pageHandle) return pageHandle;
    return null;
  }

  function insertBuyNowButton(srcEl, handle) {
    if (!srcEl || !srcEl.parentNode) return;
    if (srcEl.parentNode.querySelector('[data-leu-buy-now]')) return;
    var buyBtn = document.createElement('button');
    buyBtn.setAttribute('type', 'button');
    buyBtn.className = 'leu-buy-now-injected';
    buyBtn.setAttribute('data-leu-buy-now', '');
    buyBtn.setAttribute('data-leu-handle', handle);
    buyBtn.setAttribute('aria-label', 'Buy now — express checkout');
    var label = document.createElement('span');
    label.textContent = 'BUY NOW →';
    buyBtn.appendChild(label);
    var wrap = document.createElement('div');
    wrap.className = 'leu-buy-now-wrap-injected';
    wrap.appendChild(buyBtn);
    srcEl.parentNode.insertBefore(wrap, srcEl);
  }

  function restyleATC(el) {
    if (!el) return;
    el.classList.add('leu-atc-restyled');
    try { el.style.removeProperty('width'); el.style.removeProperty('max-width'); el.style.removeProperty('margin-top'); } catch (e) {}
  }

  function rewriteBuyButtons() {
    var candidates = document.querySelectorAll('a, button');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.dataset.leuBuyHijacked) continue;
      var text = (el.textContent || '').trim();
      var href = el.getAttribute && el.getAttribute('href');
      var isBuyText = /^(buy now|buy|shop|order now)$/i.test(text);
      var isChlHref = href && /coasthighwayliquor\.myshopify\.com/i.test(href);
      if (!isBuyText && !isChlHref) continue;
      var leuHandle = resolveLeuHandle(el);
      if (!leuHandle) continue;
      el.dataset.leuBuyHijacked = '1';
      try {
        if (text === text.toUpperCase()) el.textContent = 'ADD TO CART';
        else if (text === text.toLowerCase()) el.textContent = 'add to cart';
        else el.textContent = 'Add to cart';
      } catch (e) {}
      el.addEventListener('click', function (handle) {
        return function (ev) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (!window.LeucadiaCart || !window.LEUCADIA_CHL || !window.LEUCADIA_CHL.lookup) return;
          var meta = window.LEUCADIA_CHL.lookup(handle);
          if (!meta) { console.warn('[Leucadia] no CHL mapping for', handle); return; }
          var scope = ev.currentTarget.closest('section, .shopify-section, [class*="section"]') || document.body;
          var img = scope.querySelector('img');
          window.LeucadiaCart.add({ key: handle, chlVariantId: meta.variantId, title: meta.title, price: meta.price, image: img && img.src ? img.src : '', qty: 1 });
          window.LeucadiaCart.open();
        };
      }(leuHandle), true);
      insertBuyNowButton(el, leuHandle);
      restyleATC(el);
    }
  }

  function syncCount() {
    var count = leuCartCount();
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var b = bubbles[i];
      var numSpan = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span:not(.visually-hidden)') || b;
      if (numSpan) numSpan.textContent = count > 0 ? count : '';
      b.style.display = count > 0 ? '' : 'none';
    }
    if (!bubbles.length) {
      var cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
      if (cartIcon) {
        var leuSpan = cartIcon.querySelector('.leu-cart-count');
        if (!leuSpan && count > 0) {
          leuSpan = document.createElement('span');
          leuSpan.className = 'leu-cart-count';
          leuSpan.style.cssText = 'position:absolute;top:-4px;right:-4px;min-width:18px;height:18px;padding:0 4px;border-radius:9px;background:#D4AF50;color:#080808;font-family:sans-serif;font-size:11px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;z-index:5;';
          cartIcon.style.position = cartIcon.style.position || 'relative';
          cartIcon.appendChild(leuSpan);
        }
        if (leuSpan) {
          if (count > 0) leuSpan.textContent = count;
          else leuSpan.remove();
        }
      }
    }
  }

  function hideDawnDrawer() {
    var dawn = document.querySelector('cart-drawer');
    if (dawn) dawn.style.display = 'none';
    var notif = document.querySelector('cart-notification');
    if (notif) notif.style.display = 'none';
  }

  function init() {
    injectBuyNowStyles();
    hijackCartLinks();
    rewriteBuyButtons();
    syncCount();
    hideDawnDrawer();
  }

  document.addEventListener('leucadia:cart:change', syncCount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setTimeout(init, 1500);
  setTimeout(init, 3500);
  setTimeout(init, 6500);
})();
